import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppName, AppUrl } from '../microfrontend.tokens';
import { MfSettingsComponent } from './mf-settings.component';
import { UnsavedChangesModule } from '../../shared/components/unsaved-changes/unsaved-changes.module';
import { CreateSequenceModule } from '@web-frontend/shared/components/create-sequence/create-sequence.module';

const microfrontendKey = 'mf-settings';

@NgModule({
  imports: [CommonModule, UnsavedChangesModule, CreateSequenceModule],
  declarations: [MfSettingsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: AppName,
      useValue: microfrontendKey,
    },
    {
      provide: AppUrl,
      useFactory: () => {
        return localStorage.getItem(microfrontendKey);
      },
    },
  ],
  exports: [MfSettingsComponent],
})
export class MfSettingsModule {}
